export default class ReviewsClient {
    constructor(apiClient) {
        this.baseURI = '/v3/reviews';
        this.apiClient = apiClient;
        this.putReview = this.putReview.bind(this);
        this.putReviewRewards = this.putReviewRewards.bind(this);
        this.getReviewVersion = this.getReviewVersion.bind(this);
        this.getReviewVersions = this.getReviewVersions.bind(this);
        this.postReviewsSearch = this.postReviewsSearch.bind(this);
        this.postReviewsHistogram = this.postReviewsHistogram.bind(this);
        this.getReview = this.getReview.bind(this);
    }
    putReview(id, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}`, data, config);
    }
    putReviewRewards(id, data, config) {
        return this.apiClient.put(`${this.baseURI}/${id}/rewards`, data, config);
    }
    getReviewVersion(id, updateId, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/versions/${updateId}}`, config);
    }
    getReviewVersions(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}/versions}`, config);
    }
    postReviewsSearch(data, config) {
        return this.apiClient.post('/v3/review_searches', data, config);
    }
    postReviewsHistogram(data, config) {
        return this.apiClient.post('/v3/review_histograms', data, config);
    }
    getReview(id, config) {
        return this.apiClient.get(`${this.baseURI}/${id}`, config);
    }
}
